import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ERROR_FEATURE_KEY, ErrorState, getError} from 'app/core/components/error-page/state/error.reducer';

export const selectErrorState = createFeatureSelector<ErrorState>(ERROR_FEATURE_KEY);

export const selectError = createSelector(selectErrorState, getError);
